:host {
  display: inline-flex;

  --omk-icon-size: 24px;
  --md-focus-ring-color: var(--omk-sys-focus-ring-colour);
  --md-focus-ring-width: var(--omk-sys-focus-ring-width);

  --_omk-filled-icon-button-container-color: var(--omk-filled-icon-button-container-color, var(--omk-sys-grad-fresh-heritage-resting));
  --_omk-filled-icon-button-container-shape: var(--omk-filled-icon-button-container-shape, var(--omk-dimension-border-radius-full));
  --_omk-filled-icon-button-disabled-container-color: var(--omk-filled-icon-button-disabled-container-color, var(--omk-colour-container-disabled-resting));
  --_omk-filled-icon-button-disabled-container-opacity: var(--omk-filled-icon-button-disabled-container-opacity, 1);
  --_omk-filled-icon-button-disabled-icon-color: var(--omk-filled-icon-button-disabled-icon-color, var(--omk-colour-icon-disabled-disabled));
  --_omk-filled-icon-button-disabled-icon-opacity: var(--omk-filled-icon-button-disabled-icon-opacity, 1);
  --_omk-filled-icon-button-focus-icon-color: var(--omk-filled-icon-button-focus-icon-color, var(--omk-colour-icon-inverse-resting));
  --_omk-filled-icon-button-hover-icon-color: var(--omk-filled-icon-button-hover-icon-color, var(--omk-colour-icon-inverse-resting));
  --_omk-filled-icon-button-hover-state-layer-color: var(--omk-filled-icon-button-hover-state-layer-color, var(--omk-sys-grad-fresh-heritage-hover));
  --_omk-filled-icon-button-hover-state-layer-opacity: var(--omk-filled-icon-button-hover-state-layer-opacity, 1);
  --_omk-filled-icon-button-icon-color: var(--omk-filled-icon-button-icon-color, var(--omk-colour-icon-inverse-resting));
  --_omk-filled-icon-button-icon-size: var(--omk-filled-icon-button-icon-size, 24px);
  --_omk-filled-icon-button-pressed-icon-color: var(--omk-filled-icon-button-pressed-icon-color, var(--omk-colour-icon-inverse-resting));
  --_omk-filled-icon-button-pressed-state-layer-color: var(--omk-filled-icon-button-pressed-state-layer-color, #000);
  --_omk-filled-icon-button-pressed-state-layer-opacity: var(--omk-filled-icon-button-pressed-state-layer-opacity, 0.32);

  --_omk-outlined-icon-button-container-shape: var(--omk-outlined-icon-button-container-shape, var(--omk-dimension-border-radius-full));
  --_omk-outlined-icon-button-container-color: var(--omk-outlined-icon-button-container-color, transparent);
  --_omk-outlined-icon-button-disabled-icon-color: var(--omk-outlined-icon-button-disabled-icon-color, var(--omk-colour-icon-disabled-disabled));
  --_omk-outlined-icon-button-disabled-icon-opacity: var(--omk-outlined-icon-button-disabled-icon-opacity, 1);
  --_omk-outlined-icon-button-disabled-outline-color: var(--omk-outlined-icon-button-disabled-outline-color, var(--omk-colour-border-primary-resting));
  --_omk-outlined-icon-button-disabled-outline-opacity: var(--omk-outlined-icon-button-disabled-outline-opacity, 1);
  --_omk-outlined-icon-button-focus-icon-color: var(--omk-outlined-icon-button-focus-icon-color, var(--omk-colour-icon-active-resting));
  --_omk-outlined-icon-button-hover-icon-color: var(--omk-outlined-icon-button-hover-icon-color, var(--omk-colour-icon-active-hover));
  --_omk-outlined-icon-button-hover-state-layer-color: var(--omk-outlined-icon-button-hover-state-layer-color, var(--omk-colour-container-active-primary-hover));
  --_omk-outlined-icon-button-hover-state-layer-opacity: var(--omk-outlined-icon-button-hover-state-layer-opacity, 0);
  --_omk-outlined-icon-button-icon-color: var(--omk-outlined-icon-button-icon-color, var(--omk-colour-icon-active-resting));
  --_omk-outlined-icon-button-icon-size: var(--omk-outlined-icon-button-icon-size, 24px);
  --_omk-outlined-icon-button-outline-color: var(--omk-outlined-icon-button-outline-color, var(--omk-colour-border-active-resting));
  --_omk-outlined-icon-button-outline-width: var(--omk-outlined-icon-button-outline-width, 1px);
  --_omk-outlined-icon-button-pressed-icon-color: var(--omk-outlined-icon-button-pressed-icon-color, var(--omk-colour-icon-active-press));
  --_omk-outlined-icon-button-pressed-state-layer-color: var(--omk-outlined-icon-button-pressed-state-layer-color, var(--omk-colour-container-active-primary-press));
  --_omk-outlined-icon-button-pressed-state-layer-opacity: var(--omk-outlined-icon-button-pressed-state-layer-opacity, 1);

  --_omk-outlined-icon-button-hover-outline-color: var(--omk-outlined-icon-button-hover-outline-color, var(--omk-colour-border-active-hover));
  --_omk-outlined-icon-button-pressed-outline-color: var(--omk-outlined-icon-button-pressed-outline-color, var(--omk-colour-border-active-press));

  --_omk-outlined-icon-button-disabled-container-color: var(--omk-outlined-icon-button-disabled-container-color, var(--omk-colour-container-disabled-resting));

  --_omk-ghost-outlined-icon-button-focus-icon-color: var(--omk-ghost-outlined-icon-button-focus-icon-color, var(--omk-colour-icon-inverse-resting));
  --_omk-ghost-outlined-icon-button-icon-color: var(--omk-ghost-outlined-icon-button-icon-color, var(--omk-colour-icon-inverse-resting));
  --_omk-ghost-outlined-icon-button-outline-color: var(--omk-ghost-outlined-icon-button-outline-color, var(--omk-colour-border-inverse-resting));

  --_omk-icon-button-disabled-icon-color: var(--omk-icon-button-disabled-icon-color, var(--omk-colour-icon-disabled-disabled));
  --_omk-icon-button-disabled-icon-opacity: var(--omk-icon-button-disabled-icon-opacity, 1);
  --_omk-icon-button-focus-icon-color: var(--omk-icon-button-focus-icon-color, var(--omk-colour-icon-active-resting));
  --_omk-icon-button-hover-icon-color: var(--omk-icon-button-hover-icon-color, var(--omk-colour-icon-active-hover));
  --_omk-icon-button-hover-state-layer-color: var(--omk-icon-button-hover-state-layer-color, var(--omk-colour-container-active-primary-hover));
  --_omk-icon-button-hover-state-layer-opacity: var(--omk-icon-button-hover-state-layer-opacity, 1);
  --_omk-icon-button-icon-color: var(--omk-icon-button-icon-color, var(--omk-colour-icon-active-resting));
  --_omk-icon-button-icon-size: var(--omk-icon-button-icon-size, 24px);
  --_omk-icon-button-pressed-icon-color: var(--omk-icon-button-pressed-icon-color, var(--omk-colour-icon-active-press));
  --_omk-icon-button-pressed-state-layer-color: var(--omk-icon-button-pressed-state-layer-color, var(--omk-colour-container-active-primary-press));
  --_omk-icon-button-pressed-state-layer-opacity: var(--omk-icon-button-pressed-state-layer-opacity, 1);
  --_omk-icon-button-state-layer-shape: var(--omk-icon-button-state-layer-shape, var(--omk-dimension-border-radius-full));
  --_omk-icon-button-regular-size: var(--omk-icon-button-regular-size, var(--omk-dimension-units-10));
  --_omk-icon-button-large-size: var(--omk-icon-button-large-size, var(--omk-dimension-units-13));

  --_omk-ghost-icon-button-focus-icon-color: var(--omk-ghost-icon-button-focus-icon-color, var(--omk-colour-icon-inverse-resting));
  --_omk-ghost-icon-button-icon-color: var(--omk-ghost-icon-button-icon-color, var(--omk-colour-icon-inverse-resting));

  --_omk-standard-icon-button-focus-icon-color: var(--omk-standard-icon-button-focus-icon-color, var(--omk-colour-icon-primary-resting));
  --_omk-standard-icon-button-hover-icon-color: var(--omk-standard-icon-button-hover-icon-color, var(--omk-colour-icon-primary-resting));
  --_omk-standard-icon-button-icon-color: var(--omk-standard-icon-button-icon-color, var(--omk-colour-icon-primary-resting));
  --_omk-standard-icon-button-pressed-icon-color: var(--omk-standard-icon-button-pressed-icon-color, var(--omk-colour-icon-primary-resting));

  --md-filled-icon-button-container-color: none;
  --md-filled-icon-button-container-shape: var(--_omk-filled-icon-button-container-shape);
  --md-filled-icon-button-disabled-container-color: var(--_omk-filled-icon-button-disabled-container-color);
  --md-filled-icon-button-disabled-container-opacity: var(--_omk-filled-icon-button-disabled-container-opacity);
  --md-filled-icon-button-disabled-icon-color: var(--_omk-filled-icon-button-disabled-icon-color);
  --md-filled-icon-button-disabled-icon-opacity: var(--_omk-filled-icon-button-disabled-icon-opacity);
  --md-filled-icon-button-focus-icon-color: var(--_omk-filled-icon-button-focus-icon-color);
  --md-filled-icon-button-hover-icon-color: var(--_omk-filled-icon-button-hover-icon-color);
  --md-filled-icon-button-hover-state-layer-color: none;
  --md-filled-icon-button-hover-state-layer-opacity: var(--_omk-filled-icon-button-hover-state-layer-opacity);
  --md-filled-icon-button-icon-color: var(--_omk-filled-icon-button-icon-color);
  --md-filled-icon-button-icon-size: var(--_omk-filled-icon-button-icon-size);
  --md-filled-icon-button-pressed-icon-color: var(--_omk-filled-icon-button-pressed-icon-color);
  --md-filled-icon-button-pressed-state-layer-color: var(--_omk-filled-icon-button-pressed-state-layer-color);
  --md-filled-icon-button-pressed-state-layer-opacity: var(--_omk-filled-icon-button-pressed-state-layer-opacity);

  --md-outlined-icon-button-container-shape: var(--_omk-outlined-icon-button-container-shape);
  --md-outlined-icon-button-disabled-icon-color: var(--_omk-outlined-icon-button-disabled-icon-color);
  --md-outlined-icon-button-disabled-icon-opacity: var(--_omk-outlined-icon-button-disabled-icon-opacity);
  --md-outlined-icon-button-disabled-outline-color: var(--_omk-outlined-icon-button-disabled-outline-color);
  --md-outlined-icon-button-disabled-outline-opacity: var(--_omk-outlined-icon-button-disabled-outline-opacity);
  --md-outlined-icon-button-focus-icon-color: var(--_omk-outlined-icon-button-focus-icon-color);
  --md-outlined-icon-button-hover-icon-color: var(--_omk-outlined-icon-button-hover-icon-color);
  --md-outlined-icon-button-hover-state-layer-color: var(--_omk-outlined-icon-button-hover-state-layer-color);
  --md-outlined-icon-button-hover-state-layer-opacity: var(--_omk-outlined-icon-button-hover-state-layer-opacity);
  --md-outlined-icon-button-icon-color: var(--_omk-outlined-icon-button-icon-color);
  --md-outlined-icon-button-icon-size: var(--_omk-outlined-icon-button-icon-size);
  --md-outlined-icon-button-outline-color: var(--_omk-outlined-icon-button-outline-color);
  --md-outlined-icon-button-outline-width: var(--_omk-outlined-icon-button-outline-width);
  --md-outlined-icon-button-pressed-icon-color: var(--_omk-outlined-icon-button-pressed-icon-color);
  --md-outlined-icon-button-pressed-state-layer-color: var(--_omk-outlined-icon-button-pressed-state-layer-color);
  --md-outlined-icon-button-pressed-state-layer-opacity: var(--_omk-outlined-icon-button-pressed-state-layer-opacity);

  --md-icon-button-disabled-icon-color: var(--_omk-icon-button-disabled-icon-color);
  --md-icon-button-disabled-icon-opacity: var(--_omk-icon-button-disabled-icon-opacity);
  --md-icon-button-focus-icon-color: var(--_omk-icon-button-focus-icon-color);
  --md-icon-button-hover-icon-color: var(--_omk-icon-button-hover-icon-color);
  --md-icon-button-hover-state-layer-color:  var(--_omk-icon-button-hover-state-layer-color);
  --md-icon-button-hover-state-layer-opacity: var(--_omk-icon-button-hover-state-layer-opacity);
  --md-icon-button-icon-color: var(--_omk-icon-button-icon-color);
  --md-icon-button-icon-size: var(--_omk-icon-button-icon-size);
  --md-icon-button-pressed-icon-color: var(--_omk-icon-button-pressed-icon-color);
  --md-icon-button-pressed-state-layer-color: var(--_omk-icon-button-pressed-state-layer-color);
  --md-icon-button-pressed-state-layer-opacity: var(--_omk-icon-button-pressed-state-layer-opacity);
  --md-icon-button-state-layer-shape: var(--_omk-icon-button-state-layer-shape);


  md-icon {
    font-size: inherit;
  }
}

.btn-regular {
  --md-filled-icon-button-container-height: var(--_omk-icon-button-regular-size);
  --md-filled-icon-button-container-width: var(--_omk-icon-button-regular-size);
  --md-outlined-icon-button-container-height: var(--_omk-icon-button-regular-size);
  --md-outlined-icon-button-container-width: var(--_omk-icon-button-regular-size);
  --md-icon-button-state-layer-height: var(--_omk-icon-button-regular-size);
  --md-icon-button-state-layer-width: var(--_omk-icon-button-regular-size);
}

.btn-large {
  --md-filled-icon-button-container-height: var(--_omk-icon-button-large-size);
  --md-filled-icon-button-container-width: var(--_omk-icon-button-large-size);
  --md-outlined-icon-button-container-height: var(--_omk-icon-button-large-size);
  --md-outlined-icon-button-container-width: var(--_omk-icon-button-large-size);
  --md-icon-button-state-layer-height: var(--_omk-icon-button-large-size);
  --md-icon-button-state-layer-width: var(--_omk-icon-button-large-size);

}

.standard-btn {
  --md-icon-button-focus-icon-color: var(--_omk-standard-icon-button-focus-icon-color);
  --md-icon-button-hover-icon-color: var(--_omk-standard-icon-button-hover-icon-color);
  --md-icon-button-icon-color: var(--_omk-standard-icon-button-icon-color);
  --md-icon-button-pressed-icon-color: var(--_omk-standard-icon-button-pressed-icon-color);
}

:host([disabled]) {
  pointer-events: none;
}

md-outlined-icon-button:not([disabled]) {
  &:hover
  {
    --md-outlined-icon-button-outline-color: var(--_omk-outlined-icon-button-hover-outline-color);
    --md-outlined-icon-button-outline-width: var(--omk-dimension-border-width-normal);
  }

  &:active
  {
    --md-outlined-icon-button-outline-color: var(--_omk-outlined-icon-button-pressed-outline-color);
    --md-outlined-icon-button-outline-width: var(--omk-dimension-border-width-normal);
  }
}

.ghost-mode {
  --md-outlined-icon-button-focus-icon-color: var(--_omk-ghost-outlined-icon-button-focus-icon-color);
  --md-outlined-icon-button-icon-color: var(--_omk-ghost-outlined-icon-button-icon-color);
  --md-outlined-icon-button-outline-color: var(--_omk-ghost-outlined-icon-button-outline-color);

  --md-icon-button-focus-icon-color: var(--_omk-ghost-icon-button-focus-icon-color);
  --md-icon-button-icon-color: var(--_omk-ghost-icon-button-icon-color);
}

md-outlined-icon-button:not([disabled]).ghost-mode:hover {
  --md-outlined-icon-button-focus-icon-color: var(--_omk-outlined-icon-button-hover-icon-color);
}

md-icon-button:not([disabled]).ghost-mode:hover {
  --md-icon-button-focus-icon-color: var(--_omk-icon-button-hover-icon-color);
}
md-outlined-icon-button {
  ::slotted(img) {
    width: var(--_omk-outlined-icon-button-icon-size);
    height: var(--_omk-outlined-icon-button-icon-size);
  }
}

md-icon-button {
  ::slotted(img) {
    width: var(--_omk-icon-button-icon-size);
    height: var(--_omk-icon-button-icon-size);
  }
}